import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (token) =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });

export const BUSINESS = {
  remodel: "Sleek Renovations",
  showroom: "Sleek Kitchen & Bath",
  address: "168 Main Street, Northborough, MA 01532",
  phone: "(781) 760-4524",
  phoneHref: "tel:+17817604524",
  email: "chris@sleekrenovations.com",
  emailHref: "mailto:chris@sleekrenovations.com",
  mapsHref: "https://www.google.com/maps/dir/?api=1&destination=168+Main+Street,+Northborough,+MA+01532",
  appStoreUrl: "",
};

// UTM capture — persists first-touch attribution across the session.
// Call captureUtm() once on app boot; then getUtm() returns the stash for form submits.
const UTM_KEY = "sleek_utm";

export function captureUtm() {
  if (typeof window === "undefined") return;
  try {
    const sp = new URLSearchParams(window.location.search);
    const gclid = sp.get("gclid") || "";
    const fresh = {
      utm_source: sp.get("utm_source") || (gclid ? "google" : ""),
      utm_medium: sp.get("utm_medium") || (gclid ? "cpc" : ""),
      utm_campaign: sp.get("utm_campaign") || (gclid ? "auto-tagged (gclid)" : ""),
      utm_term: sp.get("utm_term") || "",
      utm_content: sp.get("utm_content") || "",
      landing_url: window.location.href,
    };
    // Only capture when a UTM landed AND nothing is stored yet — preserves first-touch.
    if (fresh.utm_source && !sessionStorage.getItem(UTM_KEY)) {
      sessionStorage.setItem(UTM_KEY, JSON.stringify(fresh));
    }
  } catch (err) {
    // sessionStorage may be unavailable in private mode
    console.debug("UTM capture skipped:", err?.message);
  }
}

export function getUtm() {
  if (typeof window === "undefined") return { utm_source: "", utm_medium: "", utm_campaign: "" };
  try {
    const raw = sessionStorage.getItem(UTM_KEY);
    if (!raw) return { utm_source: "", utm_medium: "", utm_campaign: "" };
    return JSON.parse(raw);
  } catch {
    return { utm_source: "", utm_medium: "", utm_campaign: "" };
  }
}
